<template>
  <div>
    <el-dialog
      title="收货记录"
      custom-class="receipt-history-dialog"
      :visible.sync="listVisible"
      width="1180px"
      :close-on-click-modal="false"
      append-to-body
      @close="handleListClose"
    >
      <div class="receipt-history-meta">
        <span>采购单号：{{ orderMeta.orderNo || "-" }}</span>
        <span>店铺：{{ orderMeta.shopName || "-" }}</span>
        <span>供应商：{{ orderMeta.supplierName || "-" }}</span>
      </div>
      <el-table
        :data="receiptList"
        border
        stripe
        size="mini"
        max-height="460"
        v-loading="listLoading"
        element-loading-text="加载中..."
        empty-text="暂无收货记录"
      >
        <el-table-column type="index" label="序号" width="48" align="center"></el-table-column>
        <el-table-column prop="receiptNo" label="收货单号" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="receiptTypeLabel" label="类型" width="90" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.receiptTypeLabel" size="mini" :type="getReceiptTypeTag(scope.row.receiptType)" effect="light">
              {{ scope.row.receiptTypeLabel }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.voided ? 'info' : 'success'" effect="light">
              {{ scope.row.voided ? "已作废" : "生效" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="lineCount" label="明细行数" width="72" align="right"></el-table-column>
        <el-table-column prop="batchArrived" label="本批实收" width="72" align="right"></el-table-column>
        <el-table-column prop="qualityFail" label="质检不合格" width="88" align="right"></el-table-column>
        <el-table-column prop="outOfStock" label="缺货" width="64" align="right"></el-table-column>
        <el-table-column prop="overStock" label="多到" width="64" align="right"></el-table-column>
        <el-table-column prop="createUser" label="创建人" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTimeLabel" label="创建时间" width="150"></el-table-column>
        <el-table-column prop="voidReason" label="作废原因" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.voidReason || "-" }}</template>
        </el-table-column>
        <el-table-column label="操作" width="132" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openDetail(scope.row)">查看明细</el-button>
            <el-button
              v-if="scope.row.canVoid"
              type="text"
              size="mini"
              class="void-btn"
              :loading="voidingId === scope.row._id"
              @click="onVoid(scope.row)"
            >
              作废
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="listVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :title="detailTitle"
      custom-class="receipt-detail-dialog"
      :visible.sync="detailVisible"
      width="1100px"
      :close-on-click-modal="false"
      append-to-body
      @close="handleDetailClose"
    >
      <div class="receipt-history-meta">
        <span>类型：{{ detailMeta.receiptTypeLabel || "-" }}</span>
        <span>状态：{{ detailMeta.voided ? "已作废" : "生效" }}</span>
        <span>创建人：{{ detailMeta.createUser || "-" }}</span>
        <span>创建时间：{{ detailMeta.createTimeLabel || "-" }}</span>
      </div>
      <div v-if="detailMeta.voided" class="receipt-void-meta">
        <span>作废人：{{ detailMeta.voidUser || "-" }}</span>
        <span>作废时间：{{ detailMeta.voidTimeLabel || "-" }}</span>
        <span>作废原因：{{ detailMeta.voidReason || "-" }}</span>
      </div>
      <el-table
        :data="detailLines"
        border
        stripe
        size="mini"
        max-height="460"
        show-summary
        :summary-method="getDetailSummaries"
        v-loading="detailLoading"
        element-loading-text="加载中..."
        empty-text="暂无收货明细"
      >
        <el-table-column type="index" label="序号" width="48" align="center"></el-table-column>
        <el-table-column prop="sku" label="SKU" min-width="180" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="purchaseColorName" label="颜色" width="72" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="model" label="机型" width="80" show-overflow-tooltip></el-table-column>
        <el-table-column prop="planPurchase" label="采购数量" width="72" align="right"></el-table-column>
        <el-table-column prop="batchArrived" label="本批实收" width="96" align="right">
          <template slot-scope="scope">
            <el-input v-if="detailEditable" v-model="scope.row.batchArrived" type="number" size="mini"></el-input>
            <span v-else>{{ scope.row.batchArrived }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="qualityFail" label="质检不合格" width="110" align="right">
          <template slot-scope="scope">
            <el-input v-if="detailEditable" v-model="scope.row.qualityFail" type="number" size="mini"></el-input>
            <span v-else>{{ scope.row.qualityFail }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="outOfStock" label="缺货" width="64" align="right"></el-table-column>
        <el-table-column prop="overStock" label="多到" width="96" align="right">
          <template slot-scope="scope">
            <el-input v-if="detailEditable" v-model="scope.row.overStock" type="number" size="mini"></el-input>
            <span v-else>{{ scope.row.overStock }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailVisible = false">关 闭</el-button>
        <el-button
          v-if="detailMeta.canVoid && !detailMeta.voided"
          type="danger"
          plain
          size="small"
          :loading="voidingId === detailMeta._id"
          @click="onVoid(detailMeta)"
        >
          作废
        </el-button>
        <el-button v-if="detailEditable" type="primary" size="small" :loading="detailSaving" @click="saveDetail">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requestModules } from "@r";

const RECEIPT_TYPE = {
  FINAL: 1,
  REPLENISH: 2,
  PARTIAL: 3,
};

const DETAIL_SUM_PROPS = ["planPurchase", "batchArrived", "qualityFail", "outOfStock", "overStock"];

export default {
  name: "ReceiptHistoryDialog",
  data() {
    return {
      listVisible: false,
      listLoading: false,
      receiptList: [],
      orderMeta: {
        orderNo: "",
        shopName: "",
        supplierName: "",
      },
      orderId: "",
      voidingId: "",
      detailVisible: false,
      detailLoading: false,
      detailSaving: false,
      detailLines: [],
      detailMeta: {
        _id: "",
        receiptNo: "",
        receiptType: 0,
        receiptTypeLabel: "",
        voided: false,
        canEdit: false,
        canVoid: false,
        voidReason: "",
        voidUser: "",
        voidTimeLabel: "",
        createUser: "",
        createTimeLabel: "",
      },
    };
  },
  computed: {
    detailTitle() {
      return this.detailMeta.receiptNo ? "收货明细 - " + this.detailMeta.receiptNo : "收货明细";
    },
    detailEditable() {
      return !!this.detailMeta.canEdit && !this.detailMeta.voided;
    },
  },
  methods: {
    open(row) {
      const orderId = row && (row.orderId || row._id);
      if (!orderId) {
        this.$message.warning("缺少采购单ID");
        return;
      }
      this.orderMeta = {
        orderNo: (row && row.orderNo) || "",
        shopName: (row && row.shopName) || "",
        supplierName: (row && (row.supplierShortName || row.supplierName)) || "",
      };
      this.orderId = orderId;
      this.receiptList = [];
      this.listVisible = true;
      this.listLoading = true;
      requestModules
        .fetchPurchaseOrderReceiptHistory({ orderId })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取收货记录失败");
            this.listVisible = false;
            return;
          }
          const meta = res.mdata || {};
          this.orderMeta = {
            orderNo: meta.orderNo || this.orderMeta.orderNo,
            shopName: meta.shopName || this.orderMeta.shopName,
            supplierName: meta.supplierName || this.orderMeta.supplierName,
          };
          this.receiptList = (res.ldata || []).map(item => ({
            ...item,
            createTimeLabel: this.formatTime(item.createTime),
          }));
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取收货记录失败");
          this.listVisible = false;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    openDetail(row) {
      if (!row || !row._id) {
        this.$message.warning("缺少收货单ID");
        return;
      }
      this.detailMeta = {
        _id: row._id,
        receiptNo: row.receiptNo || "",
        receiptType: row.receiptType || 0,
        receiptTypeLabel: row.receiptTypeLabel || "",
        voided: !!row.voided,
        canEdit: !!row.canEdit,
        canVoid: !!row.canVoid,
        voidReason: row.voidReason || "",
        voidUser: row.voidUser || "",
        voidTimeLabel: this.formatTime(row.voidTime),
        createUser: row.createUser || "",
        createTimeLabel: row.createTimeLabel || this.formatTime(row.createTime),
      };
      this.detailLines = [];
      this.detailVisible = true;
      this.detailLoading = true;
      requestModules
        .fetchPurchaseOrderReceiptDetail({ receiptId: row._id })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "获取收货明细失败");
            this.detailVisible = false;
            return;
          }
          const meta = res.mdata || {};
          this.detailMeta = {
            _id: meta._id || this.detailMeta._id,
            receiptNo: meta.receiptNo || this.detailMeta.receiptNo,
            receiptType: meta.receiptType || this.detailMeta.receiptType,
            receiptTypeLabel: meta.receiptTypeLabel || this.detailMeta.receiptTypeLabel,
            voided: !!meta.voided,
            canEdit: !!meta.canEdit,
            canVoid: !!meta.canVoid,
            voidReason: meta.voidReason || "",
            voidUser: meta.voidUser || "",
            voidTimeLabel: this.formatTime(meta.voidTime),
            createUser: meta.createUser || "",
            createTimeLabel: this.formatTime(meta.createTime),
          };
          this.detailLines = res.ldata || [];
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取收货明细失败");
          this.detailVisible = false;
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    getReceiptTypeTag(receiptType) {
      if (receiptType === RECEIPT_TYPE.FINAL) {
        return "success";
      }
      if (receiptType === RECEIPT_TYPE.PARTIAL) {
        return "warning";
      }
      return "info";
    },
    formatTime(ts) {
      if (!ts) return "-";
      const date = new Date(Number(ts));
      if (Number.isNaN(date.getTime())) return "-";
      if (typeof date.format === "function") {
        return date.format("yyyy-MM-dd hh:mm:ss");
      }
      const pad = n => String(n).padStart(2, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    },
    getDetailSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (DETAIL_SUM_PROPS.includes(column.property)) {
          sums[index] = (data || []).reduce((sum, row) => sum + (Number(row[column.property]) || 0), 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
    saveDetail() {
      if (!this.detailEditable || !this.detailMeta._id) {
        return;
      }
      this.detailSaving = true;
      requestModules
        .updatePurchaseOrderReceiptLines({
          receiptId: this.detailMeta._id,
          lines: JSON.stringify(
            (this.detailLines || []).map(line => ({
              purchaseOid: line.purchaseOid,
              batchArrived: line.batchArrived,
              qualityFail: line.qualityFail,
              overStock: line.overStock,
            }))
          ),
        })
        .then(res => {
          if (res.result !== 1) {
            this.$message.error(res.message || "修改收货明细失败");
            return;
          }
          if (res.mdata && res.mdata.unchanged) {
            this.$message.info("明细没有变化");
            return;
          }
          this.$message.success("保存成功");
          if (res.mdata && res.mdata.canEdit === false) {
            this.detailMeta.canEdit = false;
            this.detailMeta.canVoid = false;
          }
          this.detailLines = res.ldata || this.detailLines;
          this.$emit("success");
          this.reloadReceiptList();
        })
        .catch(err => {
          this.$message.error((err && err.message) || "修改收货明细失败");
        })
        .finally(() => {
          this.detailSaving = false;
        });
    },
    onVoid(row) {
      if (!row || !row.canVoid || row.voided) {
        return;
      }
      this.$prompt("请填写作废原因", "作废收货单", {
        confirmButtonText: "确定作废",
        cancelButtonText: "取消",
        inputType: "textarea",
        inputPlaceholder: "例如：收货数量录入错误，需重新收货",
        inputValidator: value => {
          if (!value || !String(value).trim()) return "作废原因不能为空";
          return true;
        },
      })
        .then(({ value }) => {
          this.voidingId = row._id;
          return requestModules.voidPurchaseOrderReceipt({
            receiptId: row._id,
            reason: String(value).trim(),
          });
        })
        .then(res => {
          if (!res) return;
          if (res.result !== 1) {
            this.$message.error(res.message || "作废收货单失败");
            return;
          }
          this.$message.success("已作废收货单并重算采购单");
          if (this.detailVisible && this.detailMeta._id === row._id) {
            this.detailMeta.voided = true;
            this.detailMeta.canEdit = false;
            this.detailMeta.canVoid = false;
            this.detailMeta.voidReason = "";
            this.openDetail({ ...row, voided: true, canEdit: false, canVoid: false });
          }
          this.$emit("success");
          this.reloadReceiptList();
        })
        .catch(err => {
          if (err === "cancel" || err === "close") return;
          this.$message.error((err && err.message) || "作废收货单失败");
        })
        .finally(() => {
          this.voidingId = "";
        });
    },
    reloadReceiptList() {
      if (!this.orderId) {
        return;
      }
      requestModules.fetchPurchaseOrderReceiptHistory({ orderId: this.orderId }).then(res => {
        if (res.result !== 1) {
          return;
        }
        this.receiptList = (res.ldata || []).map(item => ({
          ...item,
          createTimeLabel: this.formatTime(item.createTime),
        }));
      });
    },
    handleListClose() {
      this.receiptList = [];
      this.detailVisible = false;
    },
    handleDetailClose() {
      this.detailLines = [];
    },
  },
};
</script>

<style lang="scss">
.receipt-history-dialog,
.receipt-detail-dialog {
  .el-dialog__body {
    padding: 12px 16px;
  }

  .receipt-history-meta,
  .receipt-void-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 20px;
    margin-bottom: 10px;
    color: #606266;
    font-size: 13px;
  }

  .receipt-void-meta {
    color: #909399;
  }

  .void-btn {
    color: #f56c6c;
  }
}
</style>
